<div class="common-text-input__container"
  [id]="field.id">
  <div [class]="'common-text-field__container-box-' + (field.color?(field.color | colors:'highlightListColors'):'default')">
    <div class="common-text-input__block-header">
      <label class="common-text-input__label">
        <span class="common-text-input__text-label">{{fieldTypeFormu.titleField}}</span>
        @if(field.required){
          <span class="common-tag__mandatory-text-asterisk">*</span>
        }
        <div class="common-text-input__block-buttons">
          @if(field.description) {
            <tooltip-info [description]="field.description"
              [field]="field"></tooltip-info>
          }
          @if (field.references?.length) {
            <tooltip-law [references]="field.references"
            [field]="field"></tooltip-law>
          }
          @if (field.relatedInfo?.length) {
            <button class="common-button__icon-sm-noborder"
              pTooltip="{{'common.related-info'| afTranslate}}"
              tooltipPosition="top"
              (click)="openModalRelatedInfo(field.relatedInfo, $event)">
              <i class="lf-icon-search-text common-icon__md"></i>
            </button>
          }
          @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
            <tooltip-in-report [inReport]="fieldTypeFormu.inReport"></tooltip-in-report>
          }
        </div>
      </label>
    </div>
    @if(field.evaluatedValue?.nvarcharValue){
      <div class="common-text-field__body-container-highlight">
          <i [class]="'lf-icon-bookmarks-active common-text-field__icon-highlight common-text-field__icon-highlight--' + (field.color | colors:'highlightListColors')"></i>
          <div class="common-text-field__text-value"
            [innerHTML]="field.evaluatedValue?.nvarcharValue | trustHtml"></div>
      </div>
    }
  </div>
</div>
